import script from "./ConfirmDeletePopover.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmDeletePopover.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmDeletePopover.vue?vue&type=style&index=0&id=be16d546&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be16d546"]])

export default __exports__